(function e() {
    // Service Pages
    $(document).ready(() => {
        // Make sure schemaData exists before parsing it and it already has a placeholder for Service schema
        var schemaData = $('#schemaData');
        var schemaJson;
        var serviceSchema = null;
        if (schemaData.length > 0) {
            schemaJson = JSON.parse(schemaData.html());
            serviceSchema = schemaJson['@graph'].filter((item) => item['@type'] == 'Service');
        }

        if (!serviceSchema || serviceSchema.length === 0) {
            return;
        }

        var serviceNameText;
        var serviceDescriptionText;
        var serviceHours = [];
        var serviceLocations = [];
        var weekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

        var serviceNameTag = $('h1.header.page-title');
        if (serviceNameTag.length > 0) {
            serviceNameText = serviceNameTag.first().text().trim();
        }

        $('div.container h1').each(function () {
            // Extract service description and hours from the page
            if ($(this).text().trim().indexOf('About') > -1) {
                serviceDescriptionText = $(this).closest('div.row').find('p').first()
                    .text()
                    .trim();
            } else if ($(this).text().trim().indexOf('Hours') > -1) {
                var headingNode = $(this);
                // Pattern covering Self Serve Dog Wash Page (Text in separate div tags)
                var textNodes = headingNode.closest('div.container').find('div').filter(function () {
                    return $(this).contents().filter(function () {
                        return this.nodeType === 3 && $.trim(this.nodeValue) !== '';
                    }).length > 0;
                });

                textNodes.each(function () {
                    var isDays = false;
                    var daysRange = [];

                    $(this).text().trim().replace(/^:+|:+$/g, '')
                        .split('-')
                        .forEach((day) => {
                            if (weekDays.indexOf(day.trim()) > -1) {
                                isDays = true;
                                daysRange.push(day.trim());
                            }
                        });

                    if (isDays) {
                        var firstDayIndex = daysRange.length ? weekDays.indexOf(daysRange[0].trim()) : 0;
                        var lastDayIndex = daysRange.length > 1 ? weekDays.indexOf(daysRange[1].trim()) : 0;
                        var completeDays = weekDays.splice(firstDayIndex, lastDayIndex + 1);

                        var opens; var
                            closes;
                        $(this).next('div').text().match(/\b(1[0-2]|0?[1-9]):([0-5][0-9])\s?([AaPp][Mm])\b|\b([01]?[0-9]|2[0-3]):([0-5][0-9])\b/g)
                            .forEach((time) => {
                                if (!opens) {
                                    opens = time;
                                } else {
                                    closes = time;
                                }
                            });

                        if (opens && closes) {
                            serviceHours.push({ days: completeDays, opens, closes });
                        }
                    }
                });

                // Pattern covering Dog Grooming Page (Text in multiple p tags)
                if (serviceHours.length === 0) {
                    textNodes = headingNode.closest('div.container').find('p').filter(function () {
                        return $(this).contents().filter(function () {
                            return this.nodeType === 3 && $.trim(this.nodeValue) !== '';
                        }).length > 0;
                    });

                    textNodes.each(function () {
                        var isDays = false;
                        var daysRange = [];

                        $(this).text().trim().replace(/^:+|:+$/g, '')
                            .split('\n')
                            .forEach((timeEntry) => {
                                var timeEntry = timeEntry.trim();

                                if (timeEntry !== '' && weekDays.indexOf(timeEntry.split(' ')[0]) > -1) {
                                    var days = timeEntry.split(':')[0].trim();
                                    var times = timeEntry.split(':').slice(1, timeEntry.split(':').length).join(':').trim();

                                    daysRange = [];
                                    days.split('-').forEach((day) => {
                                        daysRange.push(day.trim());
                                    });

                                    var firstDayIndex = daysRange.length ? weekDays.indexOf(daysRange[0].trim()) : 0;
                                    var lastDayIndex = daysRange.length > 1 ? weekDays.indexOf(daysRange[1].trim()) : 0;
                                    var completeDays;

                                    if (firstDayIndex > lastDayIndex) {
                                        completeDays = weekDays;
                                    } else {
                                        completeDays = weekDays.splice(firstDayIndex, lastDayIndex);
                                    }

                                    var opens; var
                                        closes;

                                    if (times.toLowerCase() !== 'closed') {
                                        times.match(/\b(1[0-2]|0?[1-9]):([0-5][0-9])\s?([AaPp][Mm])\b|\b([01]?[0-9]|2[0-3]):([0-5][0-9])\b/g).forEach((time) => {
                                            if (!opens) {
                                                opens = time;
                                            } else {
                                                closes = time;
                                            }
                                        });
                                    }

                                    if (opens && closes) {
                                        serviceHours.push({
                                            days: completeDays, opens, closes, isClosed: false,
                                        });
                                    } else {
                                        serviceHours.push({ days: completeDays, isClosed: true });
                                    }
                                }
                            });
                    });
                }
            }
        });

        // Extract service locations from the page and create an array of objects with the required properties
        serviceLocations = $('a[href*="Stores-Show?storeID"]').map(function () {
            return {
                '@type': 'City',
                name: $(this).closest('div').find('div').eq(2)
                    .text()
                    .split(',')[0].trim(),
            };
        });

        schemaJson['@graph'][schemaJson['@graph'].length - 1] = {
            '@type': 'Service',
            name: serviceNameText || 'Service Name Not Found',
            description: serviceDescriptionText || 'Service Description Not Found',
            serviceType: serviceNameText ? `${serviceNameText} Service` : 'Service Type Not Found',
            provider: schemaJson['@graph'].length > 1 ? schemaJson['@graph'][1] : {},
            hoursAvailable: serviceHours.map((hours) => (!hours.isClosed ? {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: hours.days,
                opens: hours.opens,
                closes: hours.closes,
            } : {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: hours.days,
            })),
            areaServed: serviceLocations.length > 0 ? serviceLocations.toArray() : [],
            url: window.location.href,
        };

        var newJsonLdScript = $('<script type="application/ld+json" id="schemaData">').text(JSON.stringify(schemaJson));
        $('#schemaData').replaceWith(newJsonLdScript);
    });

    $('body').on('product:afterAttributeSelect', (e, data) => {
        var updatedSchemaData = data.data.updatedSchemaData || null;
        if (updatedSchemaData) {
            var schemaData = $('#schemaData');
            var schemaJson;
            if (schemaData.length > 0) {
                schemaJson = JSON.parse(schemaData.html());
                schemaJson['@graph'][0] = updatedSchemaData;
                var newJsonLdScript = $('<script type="application/ld+json" id="schemaData">').text(JSON.stringify(schemaJson));
                $('#schemaData').replaceWith(newJsonLdScript);
            }
        }
    });

    $('body').on('plp:afterPLPLoadMore', (e) => {
        var schemaData = $('#schemaData');
        var schemaJson;
        if (schemaData.length > 0) {
            schemaJson = JSON.parse(schemaData.html());
            var itemListElementSchema = schemaJson['@graph'][0].itemListElement;

            var newTiles = $('div.col-12.col-sm-4[data-listItem-schema]:not([data-listItem-schema="null"])');
            var itemsCount = schemaJson['@graph'][0].numberOfItems + newTiles.length;
            newTiles.each(function () {
                var listItemSchema = $(this).data('listitem-schema');
                if (listItemSchema) {
                    itemListElementSchema.push(listItemSchema);
                    $(this).removeAttr('data-listitem-schema');
                }
            });

            schemaJson['@graph'][0].itemListElement = itemListElementSchema;
            schemaJson['@graph'][0].numberOfItems = itemsCount;
            var newJsonLdScript = $('<script type="application/ld+json" id="schemaData">').text(JSON.stringify(schemaJson));
            $('#schemaData').replaceWith(newJsonLdScript);
        }
    });
}());
